export default {
  esgPlatform: {
    esgDashboard: "Panel ESG",
    esgPlatform: "Plataforma ESG",
    esgGuide: "Guía ESG",
    initialMaturityAssessment: "Evaluación inicial de madurez",
    initialMaturityAssessmentDescription:
      "¡Gracias por completar la evaluación ESG! Agradecemos su compromiso con la sostenibilidad. A continuación encontrará el informe con su desempeño actual en materia ambiental, social y de gobernanza (ESG). Los resultados se basan en el cuestionario integral que respondió, respaldado por el Grupo de Trabajo sobre Divulgaciones Financieras Relacionadas con el Clima (TCFD) y la Evaluación de Doble Materialidad de la Unión Europea.",
    myProtocol: "Mi Programa ESG",
    esgProgress: "Progreso ESG",
    common: {
      myProducts: "Mis Productos",
      esgCompliance: "Cumplimiento ESG",
      active: "Activo",
      deactivated: "Desactivado",
    },

    unit: "Unidad",
    surveyTitlePlaceholder: "Título de la Encuesta",
    selectHeading: "Seleccionar Encabezado",
    headingDeleteConfirmationText: "¿Está seguro de que desea eliminar este encabezado?",
    questionDeleteConfirmationText: "Eliminar esta pregunta eliminará permanentemente todas las respuestas enviadas por los usuarios en toda la empresa y las subempresas. Esto también afectará el progreso ESG vinculado a esta pregunta. Esta acción no se puede deshacer. ¿Desea continuar?",
    confirmDelete: "Confirmar",
    cancelDelete: "Cancelar",
    farmerSingleResponse: "Agricultor (Respuesta única para todas las fincas)",
    farmerSeparateResponse: "Agricultor (Respuesta separada para cada finca)",
    fixedFrequency: "Frecuencia Fija",
    custom: "Personalizado",
    day: "Día",
    week: "Semana",
    month: "Mes",
    quarter: "Trimestre",
    year: "Año",
    date: "Fecha",
    textField: "Campo de Texto",
    textArea: "Área de Texto",
    textFieldNumeric: "Campo de Texto Numérico",
    radioButton: "Botón de Opción",
    checkBoxes: "Casillas de Verificación",
    getDataLabel: "Obtener Datos",
    attachFiles: "Adjuntar Archivos",
    digitalSignature: "Firma Digital",
    editSurvey: "Editar Encuesta",
    editSurveyWarning: "Tenga en cuenta que la encuesta está actualmente activa, y editar una pregunta en este momento puede afectar los envíos anteriores. Para evitar cualquier problema, puede considerar crear una copia de la encuesta con el fin de realizar cambios en las preguntas.",
    clickToCreateCopy: "Haga Clic Aquí para Crear una Copia de la Encuesta",
    continueAndEdit: "Continuar y Editar",
    surveyBuilderEsg: "Constructor de Encuestas",
    loadingAssessments: "Cargando Evaluaciones...",
    noSurveysFound: "No se Encontraron Encuestas",
    searchSurveysByTitle: "Buscar encuestas por título...",
    editAssessmentQuestion: "Editar Pregunta de Evaluación",
    addAssessmentQuestion: "Agregar Pregunta de Evaluación",
    score: "Puntuación",
    whoWillAnswerThisQuestion: "¿Quién responderá esta pregunta?",
    whoWillAnswerTooltip: "Quién responderá esta pregunta.",
    questionType: "Tipo de Pregunta",
    typeOfQuestion: "Tipo de pregunta",
    titleTooltip: "Título de la pregunta",
    enterHere: "Ingrese aquí",
    condition: "Condición",
    addDataField: "Agregar Campo de Datos",
    editDataField: "Editar Campo de Datos",
    dataField: "Campo de Datos",
    dataType: "Tipo de Datos",
    fieldTitle: "Título del Campo",
    allowedFileTypes: "Tipos de Archivo Permitidos",
    selectMeasurementUnitList: "Seleccionar Lista de Unidades de Medida",
    allowUserToChangeUnitType: "Permitir al Usuario Cambiar el Tipo de Unidad",
    help: "Ayuda",
    helpTextTooltip: "Escriba un texto de ayuda para los usuarios.",
    addHelpTextForDataField: "Agregar texto de ayuda para el campo de datos",
    addOptionTooltipExtended: "Escriba la etiqueta de la opción y haga clic en 'Agregar' para insertarla",
    enterOptionLabel: "Ingrese la etiqueta de la opción",
    fileTypeImage: "Imagen (JPEG, GIF, PNG)",
    fileTypeVideo: "Video (mp4)",
    fileTypeDocx: "DOCX",
    fileTypePdf: "PDF",
    missingRequiredIdsForGetData: "¡Faltan los ID requeridos para crear GetData!",
    getDataSavedSuccessfully: "¡GetData guardado correctamente!",
    fileType: "Tipo de Archivo",
    allowMultipleAttachments: "Permitir Múltiples Adjuntos",
    allowComments: "Permitir Comentarios",
    uploadSignatureFile: "Subir Archivo de Firma",
    drawSignature: "Dibujar Firma",
    description: "Descripción",
    descriptionTooltip: "Breve descripción de la pregunta",
    addOption: "Agregar Opción",
    addOptionTooltip: "Agregar una nueva opción a la lista",
    add: "Agregar",
    pressEnterToAdd: "Presione Enter para agregar una opción o haga clic en Agregar",
    options: "Opciones",
    repeatPeriodically: "Repetir Periódicamente (Opcional)",
    repeatPeriodicallyTooltip: "Repetir periódicamente (opcional).",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    yes: "Sí",
    no: "No",
    selectDate: "Seleccionar Fecha",
    repetitionDates: "Fechas de Repetición",
    repetitionDatesTooltip: "Fechas en las que se repite la pregunta.",
    repeatsEvery: "Se Repite Cada",
    repetitions: "Repeticiones",
    selectStartDate: "Seleccionar Fecha de Inicio",
    cancel: "Cancelar",
    ok: "OK",
    submit: "Enviar",
    requireFileAttachment: "Requerir Adjuntar Archivo",
    standardSurvey: "Encuesta Estándar",
    riskAssessmentSurvey: "Encuesta de Evaluación de Riesgos",
    esgGoalSurvey: "Encuesta de Metas ESG",
    rwaSurvey: "Encuesta RWA",
    cannotGetAssessments: "No se pueden obtener las evaluaciones",
    assessmentDeletedSuccessfully: "Evaluación eliminada correctamente",
    cannotDeleteAssessment: "No se puede eliminar la evaluación",
    errorDeletingAssessment: "Error al eliminar la evaluación",
    goalProgress: "Progreso de la Meta",
    selectSegment: "Seleccionar Segmento",
    selectTopics: "Seleccionar Temas",
    selectGoal: "Seleccionar Meta",
    selectedGoal: "Meta Seleccionada",
    searchSubOrganization: "Buscar Suborganización",
    actions: "Acciones",
    licenseId: "ID de Licencia",
    exportAsCsv: "Exportar como CSV",
    registerUser: "Registrar Usuario(s)",
    enterpriseUsers: "Usuarios de la empresa",
    singleUser: "Usuario Único",
    multipleUser: "Múltiples Usuarios",
    selectStandard: "Seleccionar Estándar",
    country: "País",
    product: "Producto",
    clear: "Limpiar",
    selectStandards: "Seleccionar Estándares",
    sdgGoalsUpdated: "Objetivos SDG actualizados correctamente",
    errorLoadingSDGGoals: "Error al cargar los Objetivos SDG",
    errorUpdatingSDGGoals: "Error al actualizar los Objetivos SDG",
    allSelectedSDGGoals: "Todos los Objetivos SDG Seleccionados",
    selectSDGGoals: "Seleccionar Objetivos SDG",
    sdgGoals: "Objetivos SDG",
    title: "Plataforma ESG",
    questionTitle: "Título de la Pregunta",
    esgCompliance: "Cumplimiento ESG",
    standards: "Estándares",
    addNewStandard: "Agregar Nuevo Estándar",
    surveyType: "Tipo de Encuesta",
    addNewSurvey: "Agregar Nueva Encuesta",
    surveyDescription: "Descripción de la Encuesta",
    surveyDescriptionTT: "Ingrese la descripción de la encuesta",
    surveyInstructions: "Instrucciones de la Encuesta",
    surveyInstructionsTT: "Ingrese las instrucciones para la encuesta",
    surveyScore: "Puntuación de la Encuesta",
    surveyScoreTT: "Permitir puntuar la encuesta",
    whoWillAnswerThisSurvey: "¿Quién Responderá Esta Encuesta?",
    whoWillAnswerThisSurveyTT: "Seleccione el tipo de usuarios que responderán esta encuesta",
    typeOfTheSurvey: "Tipo de la Encuesta",
    standardTitle: "Título del Estándar",
    standardTitleTT: "Ingrese el título del estándar",
    shortCode: "Código Corto",
    shortCodeTT: "Ingrese el código corto del estándar",
    standardDescription: "Descripción del Estándar",
    standardDescriptionTT: "Ingrese la descripción del estándar",
    seal: "Sello",
    sealTT: "Seleccione el sello del estándar",
    status: "Estado",
    upload: "Subir",
    thisfieldIsRequired: "Este campo es obligatorio",
    pleaseFillRequiredFields: "Por favor complete los campos obligatorios",
    standardAddedSuccessfully: "Estándar agregado correctamente",
    errorSubmittingForm: "Error al enviar el formulario",
    createNewEsgStandard: "Crear Nuevo Estándar ESG",
    close: "Cerrar",
    settings: "Configuración",
    next: "Siguiente",
    keyIssuesAndGoals: "Temas y Metas Clave",
    keyIssuesAndGoalsTT: "Temas y metas clave del estándar",
    environmental: "Ambiental",
    issues: "Temas",
    addIssue: "Agregar Tema",
    social: "Social",
    governance: "Gobernanza",
    goals: "Metas",
    target: "Objetivo (Años)",
    questions: "Preguntas",
    type: "Tipo",
    mandatory: "Obligatorio",
    addNewGoal: "Agregar Nueva Meta",
    deleteIssueConfirmation: "¿Está seguro de que desea eliminar este tema? Eliminar este tema también eliminará permanentemente todas las metas y preguntas asociadas. Esta acción no se puede deshacer.",
    deleteGoalConfirmation: "¿Está seguro de que desea eliminar esta meta? Eliminar esta meta también eliminará permanentemente todas las preguntas asociadas. Esta acción no se puede deshacer.",
    deleteConfirmation: "¿Está seguro de que desea eliminar? Esta acción no se puede deshacer.",
    standardSettings: "Configuración del Estándar",
    standardStatus: "Estado del Estándar",
    active: "Activo",
    inactive: "Inactivo",
    approvalMethod: "Método de Aprobación",
    approveManually: "Aprobar Manualmente",
    scoreForApproval: "Puntuación para Aprobación",
    overallProtocolScore: "Puntuación General del Programa",
    overallProtocolScoreTT: "Ingrese la puntuación general del Programa",
    heading: "Encabezado",
    selectHeadingTooltip: "Seleccione un encabezado para la pregunta de la encuesta",
    survey: "Encuesta",
    goalTitle: "Título de la Meta",
    goalTitleTT: "Ingrese el título de la meta",
    goalTargetYear: "Año Objetivo de la Meta",
    environmetalScore: "Puntuación Ambiental",
    environmetalScoreTT: "Ingrese la puntuación ambiental",
    socialScore: "Puntuación Social",
    socialScoreTT: "Ingrese la puntuación social",
    governanceScore: "Puntuación de Gobernanza",
    governanceScoreTT: "Ingrese la puntuación de gobernanza",
    mandatoryApproval: "Aprobación Obligatoria",
    preview: "Vista Previa",
    pleaseAddAtLeastOneIssueAndGoal: "Agregue al menos un tema con al menos una meta antes de continuar a la vista previa.",
    noContentToPreview: "No hay contenido para previsualizar. Agregue al menos un tema y una meta.",
    standardPreview: "Vista Previa del Estándar",
    saveStandard: "Guardar Estándar",
    standardSavedSuccessfully: "¡Estándar guardado con éxito!",
    standardDeletedSuccessfully: "¡Estándar eliminado con éxito!",
    protocolDeletedSuccessfully: "¡Programa eliminado con éxito!",
    standardUpdatedSuccessfully: "¡Estándar actualizado con éxito!",
    pleaseEnterWholeNumberBetween0and100: "Por favor, ingrese un porcentaje entre 0 y 100",
    issueCreatedSuccessfully: "Tema creado con éxito",
    errorCreatingIssue: "Error al crear el tema. Por favor, inténtelo de nuevo.",
    issueTitleUpdatedSuccessfully: "Título del tema actualizado con éxito",
    errorUpdatingIssueTitle: "Error al actualizar el título del tema. Por favor, inténtelo de nuevo.",
    issueDeletedSuccessfully: "Tema eliminado con éxito",
    errorDeletingIssue: "Error al eliminar el tema. Por favor, inténtelo de nuevo.",
    goalCreatedSuccessfully: "Meta creada con éxito",
    errorCreatingGoal: "Error al crear la meta. Por favor, inténtelo de nuevo.",
    goalUpdatedSuccessfully: "Meta actualizada con éxito",
    errorUpdatingGoal: "Error al actualizar el título de la meta. Por favor, inténtelo de nuevo.",
    errorDeletingGoal: "Error al eliminar la meta. Por favor, inténtelo de nuevo.",
    goalDeletedSuccessfully: "Meta eliminada con éxito",
    standardActivatedSuccessfully: "Estándar activado con éxito",
    goalTitleRequired: "El título de la meta es obligatorio",
    questionsRequired: "Las preguntas son obligatorias",
    noSurveyAvailable: "No hay encuestas disponibles",
    myProducts: {
      addNewProduct: "Agregar Nuevo Producto",
      lastUpdated: "Última Actualización",
      addedBy: "Agregado por",
    },
    dashboard: {
      subEnterprises: "Subempresas",
      registerSubEnterprise: "Registrar Subempresa",
      exportAsCSV: "Exportar como CSV",
      enterprise: "Empresa",
      licenseID: "ID de Licencia",
      membershipPlan: "Plan de Membresía",
      activationKeys: "Claves de Activación",
      users: "Usuarios",
      registrationDate: "Fecha de Registro",
      country: "País",
      status: "Estado",

      countryPlaceholder: "Seleccionar país",
      enterpriseName: "Nombre de la Empresa",
      enterpriseNamePlaceholder: "Ingrese el nombre de la empresa",
      enterpriseEmail: "Correo Electrónico de la Empresa",
      enterpriseEmailPlaceholder: "Ingrese la dirección de correo electrónico",
      enterprisePhoneNumber: "Número de Teléfono de la Empresa",
      enterprisePhoneNumberPlaceholder: "Ingrese el número de teléfono",
      provincePlaceholder: "Ingrese la provincia/estado",
      regionPlaceholder: "Ingrese la región/distrito",
      villagePlaceholder: "Ingrese el pueblo/ciudad",
      address: "Dirección",
      province: "Provincia/Estado",
      region: "Región/Distrito",
      village: "Pueblo/Ciudad",
      addressPlaceholder: "Ingrese la dirección",
      dateOfRegistration: "Fecha de Registro",
      dateOfRegistrationPlaceholder: "Seleccione la fecha de registro",
      subscriptionUpTo: "Suscripción Hasta",
      subscriptionUpToPlaceholder: "Seleccione la fecha de finalización de la suscripción",
      products: "Productos",
      initialAssessmentReport: "Informe de Evaluación Inicial",
      enterHere: "Ingrese Aquí",
      attachInitialAssessmentReport: "Adjuntar Informe de Evaluación Inicial",
      linkWithProducts: "Vincular con Productos",
      linkWithProductsPlaceholder: "Seleccione los productos vinculados",
      uploadLogo: "Subir Logo",
      uploadLogoPlaceholder: "Suba el logo de la empresa",
      licenseIDPlaceholder: "Ingrese el ID de Licencia",

      deactivateAccount: "Desactivar Cuenta",
      activateAccount: "Activar Cuenta",
      deactivateMsg: "¿Está seguro de que desea desactivar esta cuenta?",
      activateMsg: "¿Está seguro de que desea activar esta cuenta?",
      deleteAccount: "Eliminar Cuenta",
      deleteMsg: "¿Está seguro de que desea eliminar esta cuenta?",
    },

    activate: "Activar",
    confirmation: "Confirmación",
    standardDeleteConfirmation: "¿Está seguro de que desea eliminar este estándar?",
    protocolDeleteConfirmation: "¿Está seguro de que desea eliminar este Programa?",
    surveyQuestionForTheGoal: "Pregunta de Encuesta para la Meta",
    selectExistingESGSurveyOrCreateNew: "Seleccionar encuesta ESG existente o crear una nueva",
    surveyBuilder: "Constructor de Encuestas ESG",
    surveyDetails: "Detalles de la Encuesta",
    createnewSurvey: "Crear nueva encuesta",
    startContinueSurvey: "Iniciar/Continuar Encuesta",
    surveyOverview: "Resumen de la Encuesta",
    surveyOverviewPage: {
      goalDetails: "Detalles de la Meta",
      totalQuestions: "Total de Preguntas",
      targetYear: "Año Objetivo",
      showOnlyRepeatSubmissions: "Mostrar Solo Envíos Repetidos",
      noQuestionsFound: "No se encontraron preguntas para los filtros seleccionados.",
      fallbackCategory: "Categoría {number}",
    },
    surveyTitle: "Título de la Encuesta",
    surveyTitleTT: "Ingrese el título de la encuesta",
    surveyCompletionPercentage: "Porcentaje de Finalización de la Encuesta",
    submitted: "Enviado",
    rejected: "Rechazado",
    pending: "Pendiente",
    approved: "Aprobado",
    completed: "Completado",
    notStarted: "No Iniciado",
    inProgress: "En Progreso",
    surveyProgress: "Progreso de la Encuesta",
    howToCompleteSurvey: "Cómo Completar la Encuesta",
    confirmSurveyResponse: "Está a punto de enviar su respuesta. Por favor, confirme si desea continuar.",
    progress: {
      progress: "Progreso",
      pillarProgress: {
        environmental: "Progreso ambiental",
        social: "Progreso social",
        governance: "Progreso en gobernanza",
      },
      dashboard: "Panel",
      esgProgress: "Progreso ESG",
      companyName: "Nombre de la Empresa",
      search: "Buscar",
      select: "Seleccionar",
      country: "País",
      standard: "Estándar",
      subOrganization: "Suborganización",
      protocols: "Programa",
      actions: "Acciones",
      subOrganizations: "Suborganizaciones",
      downloadReport: "Descargar Informe",
      comparison: "Comparación",
      messages: "Mensajes",
      validateData: "Validar Datos",
      recommendations: "Recomendaciones",
      ESRSIssueAndGoals: "Temas y Metas ESRS",
      protocolProgress: "Progreso General",
    },
    validation:{
      dataValidations: "Validaciones de Datos",
      validateData: "Validar Datos",
      inputData: "Datos de Entrada",
      question: "Pregunta",
      issueAndGoal: "Tema y Meta",
      environmental: "Ambiental",
      social: "Social",
      governance: "Gobernanza",
      search: "Buscar",
      select: "Seleccionar",
      answer: "Respuesta",
      farm: "Finca",
      farmLocation: "Ubicación de la Finca",
      farmGeofence: "Geocerca de la Finca",
      viewQuestionResponse: "Ver Respuesta de la Pregunta",
      viewResponse: "Ver Respuesta",
      showOnMap: "Mostrar en el mapa",
      noModuleDataAvailable: "No hay datos de módulo disponibles",
      noData: "Sin datos",
      noSelection: "Sin selección",
      noAnswer: "Sin respuesta",
      noTitle: "Sin título",
      noResponse: "Sin respuesta",
      noMeasurement: "Sin medición",
      noFile: "Sin archivo",
      viewSignature: "Ver Firma",
      noSignature: "Sin firma",
      unknownType: "Tipo desconocido",
      unknownOption: "Desconocido",
      unnamedFile: "Archivo sin nombre",
      dimitraModule: "Módulo Dimitra",
      download: "Descargar",
      comments: "Comentarios",
      currentStatus: "Estado Actual",
      updatedBy: "Actualizado Por",
      statusUpdateHistory: "Historial de Actualización de Estado",
      noHistoryYet: "Aún no hay historial.",
      finalStatus: "Estado Final",
      approveAction: "Aprobar",
      rejectAction: "Rechazar",
      reasonRequired: "Por favor, seleccione un estado e ingrese comentarios.",
      approvalSuccess: "Respuesta aprobada con éxito.",
      approvalFailed: "No se pudo aprobar la respuesta. Por favor, intente de nuevo.",
      rejectionSuccess: "Motivo del rechazo enviado con éxito.",
      rejectionFailed: "No se pudo enviar el motivo del rechazo. Por favor, intente de nuevo.",
    },
    startNewEsgProtocol: "Iniciar Nuevo Programa ESG",
    getStartedWithEsg: "Comenzar con ESG",
    getStartedEsgMsg: "Aún no se ha agregado ningún Programa. Agregue un Programa para comenzar su camino hacia una gestión y elaboración de informes ESG eficaces.",
    startEsgProtocol: "Iniciar Programa ESG",
    createNewProtocolWithoutStandard: "Crear nuevo Programa sin un estándar",
    selectEsgStandard: "Seleccionar Estándar ESG",
    addNewProtocol: "Agregar Nuevo Programa ESG",
    protocolTitle: "Título del Programa",
    subOrganization: "Suborganizaciones",
    protocolAddedMsg: "Programa agregado con éxito.",
    existingProtocols: "Programa Existente",

    protocolSettings: "Configuración del Programa",
    protocolSettingsUpdated: "Configuración del Programa actualizada con éxito.",
    failedToUploadFile: "No se pudo subir la imagen. Por favor, intente de nuevo.",
    failedToUploadFileToS3: "No se pudo subir la imagen a S3",

    selectSubOrg: "Seleccionar Suborganizaciones",
    selectSubOrgMsg: "Seleccione la suborganización para la cual está estableciendo objetivos y metas relacionados con los programas ESG (Ambiental, Social y Gobernanza). Esta opción le permite especificar qué parte de su organización es responsable de implementar y dar seguimiento a estos objetivos. Al asignar metas a suborganizaciones individuales, puede adaptar las iniciativas ESG para abordar necesidades e impactos operativos específicos, garantizando un enfoque centrado en la sostenibilidad y la gobernanza en los distintos niveles organizativos.",
    selectedSubOrg: "Suborganizaciones Seleccionadas",
    subOrgs: "Suborganizaciones",
    activityLog: "Registro de Actividad",
    activityLogFor: "Registro de Actividad de",
    activityLogDesc: "Realice un seguimiento de todos los cambios realizados en las metas, preguntas y temas ESG, incluyendo adiciones, ediciones y eliminaciones, con detalles sobre el usuario, la acción y la marca de tiempo",
    protocolActivatedSuccessfully: "Programa activado con éxito",

    activationKey: "Clave de Activación",
    userNameAndId: "Nombre de Usuario e ID",
    email: "Correo Electrónico",
    userRole: "Rol de Usuario",
    userRegistrationDate: "Fecha de Registro del Usuario",
    protocolUpdatedSuccessfully: "Programa actualizado con éxito.",

    createNewProtocol: "Crear nuevo Programa",
    myProtocols: "Mi Programa ESG",

    viewDetails: "Ver Detalles",
    viewProgressByGoal: "Ver Progreso por Meta",
    downloadReport: "Descargar Informe",
    chooseTimeFrame: "Elija el período de tiempo para el informe que desea descargar.",
    downloading: "Descargando",
    downloadingDesc: "Su informe del Programa ESG se está preparando para la descarga. Espere mientras generamos el archivo.",
    updateStatus: "Actualizar Estado",
    updateStatusDesc: "Seleccione el nuevo estado para el Programa Abrafrutas/Fruticultores para la suborganización AGRICULTURA DO VALE LTDA - AGRIVALE.",

    validationConfirm: "Confirmación",
    validationConfirmMsg: "¿Está seguro de que desea rechazar esta respuesta? El usuario deberá enviar la respuesta de nuevo. Esta acción no se puede deshacer.",
    validationRejectionReason: "Motivo del Rechazo",
    validationRejectionReasonPlaceholder: "Escriba aquí",

    inputData: "Datos de Entrada",
    question: "Pregunta",
    issueGoal: "Tema y Meta",
    surveyResponseText: "Respuesta de la Encuesta",

    goal: "Meta",
    submittedOn: "Enviado El",
    submittedBy: "Enviado Por",
    dateSubmitted: "Fecha de Envío",
    responses: "Respuestas",
    uploadedDocument: "Documento Subido",
    noFilesUploaded: "No se subieron archivos",
    getData: "Obtener Datos",
    recommendations: "Recomendaciones",
    enterYourRecommendations: "Ingrese sus recomendaciones",
    actionPlan: "Plan de Acción",
    company: "Empresa",

    subOrganizations: "Suborganizaciones",
    farms: "Fincas",
    farmers: "Agricultores",
    totalGoals: "Total de Metas",
    startDate: "Fecha de Inicio",
    deadline: "Fecha Límite",
    standard: "Estándar",
    goalsProgress: "Progreso de las Metas",
    esrsProtocol: "Programa ESRS",

    surveyResponse: {
      enterYourAnswer: "Ingrese su respuesta",
      fieldRequired: "Este campo es obligatorio",
      additionalQuestions: "Preguntas Adicionales",
      previous: "ANTERIOR",
      skip: "OMITIR",
      submitAgain: "ENVIAR DE NUEVO",
      submissionRejected: "Su envío ha sido rechazado",
      rejectionReason: "Motivo",
      submissionRehectedMsg: "El envío ha sido rechazado",
      submit: "ENVIAR",
      next: "SIGUIENTE",
      step: "Paso",
      of: "de",
      question: "Pregunta",
      errorLoadingStandard: "Error al cargar el estándar",
      errorLoadingQuestions: "Error al cargar las preguntas",
      errorSubmittingSurvey: "Error al enviar la encuesta",
      surveySubmittedSuccess: "Encuesta enviada correctamente",
      loadingGoalTitle: "Cargando título de la meta...",
      questionOf: "Pregunta {current} de {total}",
      ratingScale: {
        title: "Use la Escala de Valoración",
        description: "Para las preguntas que utilizan una escala de valoración (p. ej., de 1 a 5), tenga en cuenta lo siguiente:",
        stronglyDisagree: "1 = Totalmente en Desacuerdo",
        disagree: "2 = En Desacuerdo",
        neutral: "3 = Neutral",
        agree: "4 = De Acuerdo",
        stronglyAgree: "5 = Totalmente de Acuerdo",
        chooseNumber: "Elija el número que mejor refleje su opinión.",
      },
      instructions: {
        readCarefully: "Lea Cada Pregunta Detenidamente",
        readDescription: "Tómese su tiempo para comprender cada pregunta antes de seleccionar su respuesta. La encuesta incluye una combinación de preguntas de opción múltiple, de escala de valoración y de respuesta abierta.",
        beHonest: "Sea Honesto y Transparente",
        beHonestDescription: "Sus respuestas nos ayudarán a evaluar nuestras prácticas actuales e identificar áreas de mejora. Proporcione comentarios honestos basados en sus experiencias.",
        provideExamples: "Proporcione Ejemplos Específicos",
        provideExamplesDescription: "En las preguntas de respuesta abierta, no dude en incluir ejemplos o sugerencias específicas. Sus comentarios detallados serán de gran valor para dar forma a nuestras iniciativas ESG.",
        reviewResponses: "Revise Sus Respuestas",
        reviewResponsesDescription: "Antes de enviar la encuesta, tómese un momento para revisar sus respuestas. Asegúrese de estar satisfecho con sus respuestas y de que se hayan respondido todas las preguntas.",
        submitSurvey: "Envíe la Encuesta",
        submitSurveyDescription: "Una vez que esté seguro de sus respuestas, haga clic en el botón 'Enviar' al final de la encuesta. ¡Agradecemos enormemente su participación!",
        contactSupport: "Contáctenos para Obtener Ayuda",
        contactSupportDescription: "Si encuentra algún tema o tiene preguntas mientras completa la encuesta, comuníquese con nuestro equipo de soporte en [correo de soporte] o [número de teléfono de soporte].",
      },
      actionPlans: "Planes de Acción",
      uploadEvidence: "Suba la Evidencia",
      fileUploadSuccess: "Archivo subido correctamente",
      fileUploadError: "Error al subir el archivo",
      addSignature: "Agregar Firma",
      comments: "Comentarios",
      selectMeasurementUnit: "Seleccionar Unidad de Medida",
      unitType: "Tipo de Unidad",
      unit: "Unidad",
      selectFile: "Seleccione el archivo para subir los datos",
      dragDrop: "o arrastre y suelte aquí",
      farmOf: "Finca {current} de {total}",
      repeatSubmission: "Repetir Envío",
      submissionOf: "Envío: {current} de {total}",
      responseRejected: "Respuesta Rechazada",
      notYetSubmitted: "Aún no enviado",
      notSubmitted: "No enviado",
      upcoming: "Próximo",
      recommendations: "Recomendaciones",
      selectedOptionNotFound: "Opción seleccionada no encontrada",
      signatureRequired: "La firma es obligatoria",
      waitForFileUpload: "Por favor, espere a que el archivo se suba",
      fileRequired: "El archivo es obligatorio",
      getDataQuestions: "Preguntas de Obtener Datos",
      noResponsesToSubmit: "No hay respuestas para enviar",
      surveyCompletedSuccess: "Encuesta completada exitosamente",
    },

    validateData: "Validar Datos",
    messages: "Mensajes",
    comparision: "Comparación",
    download: "Descargar",
    issueAndGoal: "Tema y Meta",
    reasonForRejection: "Motivo del Rechazo",
    listOfUsers: "Lista de Usuarios",
    totalUsers: "Total de Usuarios",
    viewQuestionsRecommendations: "Ver Recomendaciones de Preguntas",
    protocolDetails: "Detalles del Programa",
    select: "Seleccionar",
    selectDimitraApp: "Seleccionar Aplicación Dimitra",
    selectModule: "Seleccionar Módulo",
    dimitraModuleDataFields: "Campos de Datos del Módulo Dimitra",
    selection: "Selección",
    selectModuleToViewDataFields: "Seleccione un módulo para ver los campos de datos.",
    retrieveData: "Recuperar Datos",
    noDataFieldsAvailable: "No hay campos de datos disponibles para este módulo.",
    progressMetricRules: "Reglas de la Métrica de Progreso",
    metricTitle: "Título",
    enterTitle: "Ingrese el título",
    module: "Módulo",
    datafield: "Campo de Datos",
    addAnotherModule: "Agregar Otro Módulo",
    formulaPreview: "Vista Previa:",
    conditions: "Condiciones",
    if: "Si",
    addNewCondition: "Agregar Nueva Condición",
    addProgressMetric: "Agregar Métrica de Progreso",
    yearOnYearComparisonScore: "Puntuación de Comparación Año tras Año",
    selectProgressMetric: "Seleccionar Métrica de Progreso",
    dimitraModules: "Módulos Dimitra",
    dimitraModuleCatalog: {
      modules: {
        Irrigation: "Riego",
        Harvesting: "Cosecha",
        Soil: "Gestión del Suelo",
        Farms: "Fincas",
      },
      fields: {
        "date-of-entry": "Fecha de Entrada",
        irrigation_farm: "ID de la Finca",
        farmId: "ID de la Finca",
        farmName: "Nombre de la Finca",
        "farm-name": "Nombre de la Finca",
        registrationNo: "ID de Registro de la Finca",
        farmerName: "Nombre del Agricultor",
        farmOwnershipType: "Tipo de Propiedad del Agricultor",
        farmCertifications: "Certificaciones de la Finca",
        location: "Ubicación",
        address: "Dirección de la Ubicación",
        country: "País",
        state: "Provincia/Estado",
        city: "Pueblo/Ciudad",
        farmNumber: "Número de Finca",
        farmGeofence: "Geocerca de la Finca",
        deforestationStatus: "Estado de Deforestación",
        area: "Área",
        irrigation_cropType: "Tipo de Cultivo",
        harvest_cropType: "Tipo de Cultivo",
        cropType: "Tipo de Cultivo",
        irrigation_cropVariety: "Variedad de Cultivo",
        harvesting_variety: "Variedad de Cultivo",
        waterSource: "Fuente de Agua",
        irrigation_waterSource: "Agua Superficial",
        irrigatedArea: "Área Irrigada",
        irrigation_dates: "Fecha(s) de Riego",
        irrigation_stage: "Etapa de Riego",
        irrigation_schedule: "Riego/Programación",
        totalDays: "Número Total de Días",
        irrigation_type: "Tipo de Riego",
        waterVolumeUsed: "Volumen de Agua Utilizado",
        totalNumberOfWorkers: "Número Total de Trabajadores",
        totalNumberOfHours: "Número Total de Horas",
        totalCost: "Costo Total",
        "area-planted": "Área Plantada",
        "start_date_harvesting": "Fecha de Inicio de la Cosecha",
        "end_date_harvesting": "Fecha de Finalización de la Cosecha",
        "daysHarvesting": "Número Total de Días",
        "totalFreshYield": "Rendimiento Fresco Total",
        "totalDryYield": "Rendimiento Seco Total",
        "total_planned_fresh_yield": "Rendimiento Fresco Total Planificado",
        "total_planned_dry_yield": "Rendimiento Seco Total Planificado",
        "yieldForHouseholdConsumption": "Rendimiento para Consumo del Hogar",
        "yieldForSale": "Rendimiento para Venta",
        "method_for_harvesting": "Método de Cosecha",
        "soilType": "Tipo de Suelo",
        "soilHealth": "Estado de Salud del Suelo",
        "soilPh": "pH del Suelo",
        "soilNutrientContent": "Contenido de Nutrientes del Suelo",
        "nitrogen": "Nitrógeno",
        "phosphorus": "Fósforo",
        "potassium": "Potasio",
        "sulfur": "Azufre",
        "calcium": "Calcio",
        "magnesium": "Magnesio",
        "iron": "Hierro",
        "zinc": "Zinc",
        "boron": "Boro",
        "fertilizerInputs": "Insumos de Fertilizante",
        "fertilizerName": "Nombre del Fertilizante",
        "fertilizerType": "Tipo de Fertilizante",
        "fertilizerCost": "Costo del Fertilizante",
        "applicationRate": "Tasa de Aplicación",
        "applicationMethod": "Método de Aplicación",
        "ingredientName": "Nombre del Ingrediente",
        "ingredientPercentage": "Porcentaje",
        "ingredientQuantity": "Cantidad del Ingrediente",
        "ingredientCost": "Costo del Ingrediente",
      },
    },
    esgReport: {
      esgReportBuilder: "Constructor de Informes ESG",
      accessTypes: {
        public: "Público",
        private: "Privado",
      },
      statuses: {
        saved: "Guardado",
        publishingToBlockchain: "Publicando en blockchain",
        publishToBlockchain: "Publicado en blockchain",
      },
      manageTemplates: "Gestionar Plantillas",
      createNewEsgReport: "Crear Nuevo Informe ESG",
      listOfReports: "Lista de Informes",
      reportId: "ID de Informe",
      template: "Plantilla",
      access: "Acceso",
      dateGenerated: "Fecha de Generación",
      status: "Estado",
      fileUploadFailed: "Error al subir el archivo",
      unsupportedFileFormat: "Formato de archivo no compatible",
      errorUploadingFile: "Error al subir el archivo",
      view: "Ver",
      edit: "Editar",
      download: "Descargar",
      copyAndCreateNew: "Copiar y Crear Nuevo",
      delete: "Eliminar",
      esgReportTemplates: "Plantillas de Informes ESG",
      back: "Atrás",
      createNewTemplate: "Crear Nueva Plantilla",
      listOfTemplates: "Lista de Plantillas",
      esgPlatform: "Plataforma ESG",
      reportBuilder: "Constructor de Informes",
      createTemplate: "Crear Plantilla",
      preview: "Vista Previa",
      tooltipCreateTemplate: "Agregar nueva plantilla",
      tooltipPreview: "Previsualizar y guardar su plantilla",
      deleteEsgReport: "Eliminar Informe ESG",
      confirmDeleteReportMessage: "¿Está seguro de que desea eliminar este informe?",
      cancel: "Cancelar",
      templateName: "Nombre de la Plantilla",
      nameOfTemplate: "Nombre de la Plantilla",
      next: "Siguiente",
      reportPreviewMessage: "Aquí se mostrará la vista previa del informe.",
      save: "Guardar",
      confirmationTitle: "Confirmación",
      confirmationMessage: "¿Está seguro de que desea guardar sus cambios?",
      confirm: "CONFIRMAR",
      createEsgTemplate: "Crear Plantilla ESG",
      templateSettings: "Configuración de la Plantilla",
      section: "Sección",
      addBlock: "Agregar Bloque",
      addNew: "Agregar Nuevo",
      customSections: "Secciones Personalizadas",
      databaseDrivenSections: "Secciones Basadas en Base de Datos",
      submit: "Enviar",
      heading: "Encabezado",
      paragraph: "Párrafo",
      image: "Imagen",
      stakeholders: "Partes Interesadas",
      table: "Tabla",
      esgProgressLineChart: "Gráfico de Líneas de Progreso ESG",
      esgScorecard: "Cuadro de Mando ESG",
      backgroundColor: "Color de Fondo",
      fontColor: "Color de Fuente",
      font: "Fuente",
      pdfHeader: "Encabezado de PDF",
      reportHeaderLogo: "Logo del Encabezado del Informe",
      uploadLogo: "Subir Logo",
      addImage: "Agregar Imagen",
      pleaseWait: "Por favor espere",
      defaultLogo: "Logo Predeterminado",
      scorecardSectionImages: "Imágenes de las Secciones del Scorecard",
      scorecardSectionImagesHint: "Suba imágenes de encabezado personalizadas para las secciones de Ambiental, Social y Gobernanza. Si se deja vacío, se usarán las imágenes predeterminadas.",
      sectionSettings: "Configuración de la Sección",
      selectSectionTimeline: "Seleccionar Cronograma de la Sección",
      lockSectionForSubOrganization: "Bloquear Sección para la Suborganización",
      sectionTimelineHint: "Este cronograma se aplica únicamente a esta sección",
      sectionLockedHint: "Si está bloqueada, esta sección no puede ser modificada por las suborganizaciones.",
      createEsgReport: "Crear Informe ESG",
      close: "Cerrar",
      reportTypeSelection: "Selección del Tipo de Informe",
      reportTimeline: "Cronograma del Informe",
      selectTimeline: "Seleccionar Cronograma",
      addNewSection: "Agregar una Nueva Sección",
      previewReport: "Vista Previa del Informe",
      previewPlaceholder: "Aquí se mostrará la vista previa del informe.",
      finish: "Finalizar",
      editEsgReport: "Editar Informe ESG",
      saveChanges: "Guardar Cambios",
      esgReport: "Informe ESG",
      downloadReport: "Descargar Informe",
      downloadAsPdf: "Descargar como PDF",
      downloadAsPdfNoImages: "Descargar como PDF (sin imágenes)",
      breadcrumbEsgPlatform: "Plataforma ESG",
      breadcrumbReportBuilder: "Constructor de Informes",
      breadcrumbCreateReport: "Crear Informe",
      stepReportDetails: "Detalles del Informe",
      stepReportDetailsTooltip: "Configure los detalles y la configuración del informe",
      stepCustomizeReport: "Personalizar Informe",
      stepCustomizeReportTooltip: "Agregue secciones y personalice el contenido",
      stepPreview: "Vista Previa",
      stepPreviewTooltip: "Previsualice y publique su informe",
      publicReport: "Informe Público",
      internalReport: "Informe Interno",
      confirmText: "CONFIRMAR",
      cancelText: "CANCELAR",
      closeConfirmTitle: "Confirmar Cierre",
      closeConfirmMessage: "¿Está seguro de que desea cerrar el informe? Su progreso se guardará y el estado del informe se establecerá en 'Guardado'. Puede reanudar la edición más tarde.",
      selectEsgProgram: "Seleccionar Programa ESG",
      noProtocolDetails: "No hay detalles disponibles para el programa seleccionado.",
      overallProgress: "Progreso General",
      environmentalProgress: "Progreso Ambiental",
      socialProgress: "Progreso Social",
      governanceProgress: "Progreso de Gobernanza",
      subOrganization: "Suborganización",
      environmental: "Ambiental",
      social: "Social",
      governance: "Gobernanza",
      actions: "Acciones",
      name: "Nombre",
      type: "Tipo",
      selectTemplate: "Seleccionar una Plantilla",
      createNew: "Crear Nuevo",
      startNow: "Comenzar Ahora",
      select: "Seleccionar",
      esgProgressLineGraph: "Gráfico de Líneas de Progreso ESG",
      selectEsgComponents: "Seleccionar Componentes ESG para mostrar en el gráfico:",
      componentSettings: "Configuración del Componente",
      enterSectionTitle: "Ingresar Título de la Sección",
      colorBlue: "Azul",
      colorWhite: "Blanco",
      colorPrimaryGreen: "Verde Primario",
      colorDarkGreen: "Verde Oscuro",
      colorBlack: "Negro",
      colorGrey: "Gris",
      colorCustom: "Personalizado...",
      headingSize: "Tamaño del Encabezado",
      headingTitle: "Título del Encabezado",
      overview: "Resumen",
      selectImageType: "Seleccionar Tipo de Imagen",
      singleImage: "Imagen Única",
      imageGrid: "Cuadrícula de Imágenes",
      gridSize: "Tamaño de la Cuadrícula",
      imageSize: "Tamaño de la Imagen",
      imageSizeHint: "Reduzca el ancho de la imagen si es demasiado grande y desplaza contenido a la página siguiente.",
      images: "Imágenes",
      stakeholder: "Parte Interesada",
      message: "Mensaje",
      addNewStakeholder: "Agregar Nueva Parte Interesada",
      enterMessageHere: "Ingrese el mensaje aquí",
      noOfColumns: "N.º de Columnas",
      noOfRows: "N.º de Filas",
      column: "Columna",
      columnName: "Nombre de la Columna",
      gridOfReports: "Cuadrícula de Informes",
      noReportFound: "No se encontró ningún informe",
      tableSettings: "Configuración de la Tabla",
      tableHeaderBg: "Color de Fondo del Encabezado de la Tabla",
      tablebg: "Color de Fondo de la Tabla",
      editTemplate: "Editar Plantilla",
      copy: "Copiar",
      myTemplates: "Mis Plantillas",
      organizationTemplates: "Plantillas de la Organización",
      myTemplatesHint: "Activado: muestra solo las plantillas creadas por tu sub-organización. Desactivado: muestra las plantillas de tu organización, que puedes copiar.",
      ownedByYou: "Tu plantilla",
      ownedByOrganization: "Plantilla de la organización",
      organizationTemplateReadOnlyHint: "Esta plantilla pertenece a tu organización y es de solo lectura. Usa \"Botón de Copiar\" para crear tu propia copia editable; la original no se modificará.",
      templateCopyCreatedTitle: "Nueva Copia de Plantilla Creada",
      templateCopiedMessage: "Se ha creado una copia \"{name}\" para tu sub-organización. Ya puedes editarla.",
      templateForkedOnEditMessage: "Como has editado la plantilla de la organización, se ha creado una nueva copia \"{name}\" para tu sub-organización y este informe ahora está vinculado a esa copia. La plantilla original de la organización permanece sin cambios.",
      templateCopyFailed: "No se pudo copiar la plantilla. Inténtalo de nuevo.",
      templateRelinkFailed: "No se pudo vincular este informe con tu copia de la plantilla, por lo que no se guardó nada. La plantilla original de la organización no ha cambiado. Inténtalo de nuevo.",
      templatesLoadFailed: "No se pudieron cargar las plantillas. Inténtalo de nuevo.",
      templateLoadFailed: "No se pudo cargar la plantilla. Inténtalo de nuevo."
    },
    assessmentFarmer: {
      // Shared across detail pages
      viewOnMap: "Ver en el Mapa",
      polygon: "Polígono",
      point: "Punto",
      farmGeofence: "Geocerca de la Finca",
      farmGeofenceLabel: "Geocerca de la finca",
      location: "Ubicación",
      reportDate: "Fecha del Informe",
      overallDeforestationProbability: "Probabilidad General de Deforestación",
      deforestationStatus: "Estado de Deforestación",
      viewReport: "Ver Informe",
      noDetailsAvailable: "No hay detalles disponibles.",
      moreDetailsAvailable: "+{count} detalles más disponibles",
      // Shared across pages
      responses: "Respuestas",
      company: "Empresa",
      submittedBy: "Enviado Por",
      dateSubmitted: "Fecha de Envío",
      submittedOn: "Enviado El",
      questionsPrefix: "Preguntas",
      farm: "Finca",
      additionalInformationGetData: "Información Adicional (Obtener Datos)",
      carbonFallback: "Carbono",
      soilManagementFallback: "Gestión del Suelo",
      module: "Módulo",
      details: "Detalles",
      farmDetails: "Detalles de la Finca",
      farmGeofencing: "Geocerca de la Finca",
      noResponsesFound: "No se encontraron respuestas para esta evaluación.",
      litersLabel: "{value} Litros",
      acresLabel: "{value} Acres",
      waterSource: "Fuente de Agua",
      irrigatedArea: "Área Irrigada",
      irrigationStage: "Etapa de Riego",
      cropType: "Tipo de Cultivo",
      cropVariety: "Variedad de Cultivo",
      irrigationSchedule: "Programación de Riego",
      irrigationType: "Tipo de Riego",
      totalDays: "Total de Días",
      totalWorkers: "Total de Trabajadores",
      totalHours: "Total de Horas",
      totalCost: "Costo Total",
      areaPlanted: "Área Plantada",
      startDateOfHarvesting: "Fecha de Inicio de la Cosecha",
      endDateOfHarvesting: "Fecha de Finalización de la Cosecha",
      totalNumberOfDays: "Número Total de Días",
      totalFreshYield: "Rendimiento Fresco Total",
      totalDryYield: "Rendimiento Seco Total",
      totalPlannedFreshYield: "Rendimiento Fresco Total Planificado",
      totalPlannedDryYield: "Rendimiento Seco Total Planificado",
      yieldForHouseholdConsumption: "Rendimiento para Consumo del Hogar",
      yieldForSale: "Rendimiento para Venta",
      methodOfHarvesting: "Método de Cosecha",
      // DimitraDetails
      farmLocation: "Ubicación de la Finca",
      totalArea: "Área Total",
      acres: "Acres",
      noDimitraFarmDetails: "No se encontraron detalles de finca de Dimitra para este registro.",
      noDimitraDetailsNotification: "No se encontraron detalles de Dimitra para esta selección.",
      // IrrigationDetails
      irrigationDetails: "Detalles de Riego",
      trackingContributions: "Seguimiento de sus contribuciones a la sostenibilidad.",
      irrigationCount: "Cantidad de Riegos",
      totalWaterVolumeUsed: "Volumen Total de Agua Utilizada",
      liters: "Litros",
      irrigationCountDetails: "Detalles de la Cantidad de Riegos",
      noIrrigationDetails: "No se encontraron detalles de riego para este registro.",
      noIrrigationDetailsNotification: "No se encontraron detalles de riego para esta selección.",
      // Questions
      showResponses: "Mostrar Respuestas",
      total: "Total",
      targetYear: "Año Objetivo",
      missingRouteParams: "Faltan parámetros requeridos para el enrutamiento.",
      // Responses
      dimitraModule: "Módulo Dimitra",
      actionPlans: "Planes de Acción",
      uploadedFiles: "Archivos Subidos",
      noResponse: "Sin Respuesta",
      repeatSubmission: "Repetir Envío",
      responseRejected: "Respuesta Rechazada",
      upcoming: "Próximo",
      notYetSubmitted: "Aún No Enviado",
      notSubmitted: "No Enviado",
      errorLoadingSurveyResponses: "Error al cargar las respuestas de la encuesta",
    },
    newestFirst: "Más Recientes",
    oldestFirst: "Más Antiguos",
    sort: "Ordenar",
    selectRespondents: "Seleccionar Encuestados",
    supplierServiceType: "Tipo de Servicio del Proveedor",
    selectSupplierServiceTypeTT: "Seleccione el tipo de servicio del proveedor.",
    selectServiceType: "Seleccionar Tipo de Servicio",

    // SelectSurveyUsers
    selectSurveyUsers: "Seleccionar Usuarios de la Encuesta",
    pleaseSelectUsersToProceed: "Por favor, seleccione usuario(s) para continuar",
    userSelected: "Usuario Seleccionado",
    usersSelected: "Usuarios Seleccionados",
    conditional: "Condicional",
    filterBy: "Filtrar Por",
    loadingUsers: "Cargando Usuarios...",
    searchUsers: "Buscar Usuarios",
    selectAllUsers: "Seleccionar Todos los Usuarios",
    autoConditions: "Condiciones Automáticas",
    membershipType: "Tipo de Membresía",
    memberRole: "Rol del Miembro",
    gender: "Género",
    registrationDate: "Fecha de Registro",
    startDateLabel: "Fecha de Inicio",
    endDateLabel: "Fecha de Finalización",
    conditionStatus: "Estado de la Condición",
    conditionDescription: "Los usuarios que cumplan las condiciones serán elegibles para esta encuesta automáticamente.",
    clearAll: "Limpiar Todo",
    save: "Guardar",
    all: "Todos",
    deactivated: "Desactivado",
    continue: "Continuar",
    membershipTypeDefault: "Predeterminado",
    farmer: "Agricultor",
    technician: "Técnico",
    factoryBuyingStation: "Fábrica / Estación de Compra",
    coffeeFarmer: "Agricultor de Café",
    cacaoFarmer: "Agricultor de Cacao",
    male: "Masculino",
    female: "Femenino",
    other: "Otro",
    userName: "Nombre de Usuario",
    failedToLoadSurveyUsers: "Error al cargar los usuarios de la encuesta",

    // SelectCooperatives
    selectSubOrganizations: "Seleccionar Suborganizaciones",
    pleaseSelectSubOrgsToProceed: "Por favor, seleccione Suborganizaciones para continuar",
    subOrganizationSelected: "Suborganización Seleccionada",
    subOrganizationsSelected: "Suborganizaciones Seleccionadas",
    loadingSubOrganizations: "Cargando Suborganizaciones...",
    searchSubOrganizations: "Buscar Suborganizaciones",
    selectAllSubOrganizations: "Seleccionar Todas las Suborganizaciones",
    cooperative: "Cooperativa",
    membershipPlan: "Plan de Membresía",
    membershipValidity: "Validez de la Membresía",
    failedToLoadSubOrganizations: "No se pudieron cargar las Suborganizaciones",

    // CreateSurvey
    surveyStatus: "Estado de la Encuesta",
    typeOfSurvey: "Tipo de Encuesta",
    pleaseSelectTargetYear: "Por favor, seleccione un Año Objetivo",
    yearMustBeInFuture: "El año debe ser en el futuro",
    headingUpdated: "Encabezado actualizado: {title}",
    headingCreatedSuccess: "Encabezado creado correctamente: {title}",
    headingDeletedSuccess: "Encabezado eliminado correctamente: {id}",
    headingUpdatedSuccess: "Encabezado actualizado correctamente: {order}",
    questionUpdatedSuccess: "Pregunta actualizada correctamente: {order}",
    assessmentNotFoundForId: "No se encontró la evaluación para el id",
    errorFetchingAssessmentDetails: "Error al obtener los detalles de la evaluación",
    surveyDuplicatedSuccessfully: "Encuesta duplicada correctamente",
    failedToDuplicateSurvey: "No se pudo duplicar la encuesta. Por favor, inténtelo de nuevo.",
    somethingWentWrongDuplicating: "Algo salió mal al duplicar la encuesta.",
    basicSurveySettings: "Configuración Básica de la Encuesta",
    advancedSurveySettings: "Configuración Avanzada de la Encuesta",
    moduleIntegration: "Integración de Módulos",
    questionFeatures: "Funciones de Preguntas",
    surveyTitleFieldTT: "Título de la encuesta",
    describeHere: "Describa aquí",
    scheduleEnabledLabel: "Programación Habilitada",
    selectStartEndDates: "Seleccione las fechas de inicio y de finalización para esta encuesta",
    endDate: "Fecha de Finalización",
    attachSurveyToModule: "Adjuntar Encuesta al Módulo",
    selectDimitraModuleTT: "Seleccione el módulo de Dimitra al que pertenece esta encuesta",
    selectPostAnswerActions: "Seleccionar Acciones Posteriores a la Respuesta",
    actionsAfterAnswerTT: "Acciones disponibles después de seleccionar una respuesta",
    repeatQuestionFunctionality: "Funcionalidad de Repetir Pregunta",
    enableRepeatedQuestionsTT: "Habilitar preguntas repetidas para esta encuesta",
    selectQuestionTypesLabel: "Seleccionar Tipos de Pregunta",
    questionTypesAvailableTT: "Tipos de pregunta disponibles al construir esta encuesta",
    chooseDate: "Elegir Fecha",
    selectedDate: "Fecha Seleccionada",
    selectBtn: "SELECCIONAR",
    standardLabel: "Estándar",
    startDateRequired: "La Fecha de Inicio es obligatoria",
    endDateRequired: "La Fecha de Finalización es obligatoria",
    endDateBeforeStartDate: "La Fecha de Finalización no puede ser anterior a la Fecha de Inicio",
    noModuleOptionsAvailable: "No hay opciones de módulo disponibles",
    selectedAnswererNotAvailable: "El respondedor seleccionado no está disponible para el módulo seleccionado",
    updatedSurveySuccess: "¡Encuesta actualizada correctamente!",
    createdSurveySuccess: "¡Encuesta creada correctamente!",
    errorSavingAssessment: "Error al guardar la evaluación",

    // SurveyList
    activationStatusOfSurvey: "Estado de activación de la encuesta",
    sortSurveysByDate: "Ordenar encuestas por más reciente o más antigua",
    view: "Ver",
    delete: "Eliminar",

    // General
    loading: "Cargando",

    // SurveyQuestion notifications
    unableToFetchAssessmentQuestion: "No se pudo obtener la pregunta de evaluación.",
    validationError: "Error de Validación",
    pleaseSelectHeadingBeforeSubmitting: "Por favor, seleccione un encabezado antes de enviar.",
    questionSubmittedSuccessfully: "Pregunta enviada correctamente",
    errorSubmittingAssessmentQuestion: "Error al enviar la pregunta de evaluación",
    optionAdded: "Opción Agregada",
    optionAddedSuccess: "¡Opción agregada correctamente!",
    failedToAddOption: "No se pudo agregar la opción.",
    actionPlanCreatedSuccess: "¡Plan de acción creado correctamente!",
    failedToCreateActionPlan: "No se pudo crear el plan de acción.",
    actionPlanUpdatedSuccess: "¡Plan de acción actualizado correctamente!",
    failedToUpdateActionPlan: "No se pudo actualizar el plan de acción.",
    dataFieldDeletedSuccess: "¡Campo de datos eliminado correctamente!",
    failedToDeleteDataField: "No se pudo eliminar el campo de datos.",
    error: "Error",
  },
};
